<template>
  <el-dialog width="550px" title="账号切换" :visible.sync="visible" :close-on-click-modal="false" center append-to-body>
    <div class="switch-container">
      <div class="container-box">
        <div class="text">
          <div class="text-bond">输入下方的【账号ID】并选择注册时选择的区服，即可获取游戏数据</div>
        </div>
        <img src="@/assets/black_imgs/step6.png" alt="" />
        <div class="select-box">
          <el-select v-model="serverId" placeholder="请选择区服">
            <el-option v-for="item in serverList" :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </div>
        <div class="input-box">
          <el-input v-model="openId" placeholder="请输入【Blablalink】账号ID"></el-input>
        </div>
        <div class="btn-box">
          <div class="btn back" @click="handleClose">返回</div>
          <div class="btn sure" @click="handleSure">确认</div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      openId: "",
      index: "",
      serverId: "",
      serverList: [
        {
          label: "日本/韩国/北美/东南亚/全球",
          value: 0
        },
        {
          label: "香港/澳门/台湾",
          value: 1
        }
      ]
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(bool) {
        this.$emit("input", bool);
      }
    }
  },
  methods: {
    handleClose() {
      this.openId = "";
      this.visible = false;
    },
    handleSure() {
      if (![0, 1].includes(this.serverId)) {
        return this.$message.error("请选择区服");
      }
      if (this.openId === "") {
        return this.$message.error("请输入账号id");
      }
      if (window.staticFn) {
        window.staticFn.customEvent("bind_open_id");
      }
      this.$emit("sureAccount", this.openId, this.serverId);
      this.openId = "";
    }
  }
};
</script>
<style scoped lang="less">
.switch-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .container-box {
    width: 507px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 23px;

    img {
      width: inherit;
      height: 170px;
    }

    .text {
      display: flex;
      .text-bond {
        font-weight: bold;
        font-size: 15px;
        color: #333333;
      }
    }

    .select-box {
      /deep/ .el-input {
        width: 507px !important;
        height: 48px !important;
        background: rgba(52, 144, 230, 0.05) !important;
        border-radius: 10px !important;

        .el-input__inner {
          width: inherit;
          height: inherit;
          background: inherit;
          border-radius: inherit;
        }
      }
    }
    .input-box {
      /deep/ .el-input {
        width: 507px !important;
        height: 48px !important;
        background: #ededed !important;
        border-radius: 10px !important;

        .el-input__inner {
          width: inherit;
          height: inherit;
          background: inherit;
          border-radius: inherit;
        }
      }
    }

    .btn-box {
      width: inherit;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .btn {
        width: 235px;
        height: 40px;
        border-radius: 6px;
        font-weight: bold;
        font-size: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }

      .back {
        border: 1px solid #3490e6;
        color: #3490e6;
      }

      .sure {
        background: #3490e6;
        color: #ffffff;
      }
    }
  }
}
</style>
